import styled from 'styled-components';

export const Container = styled.div({
  display: 'flex',
  flexDirection: 'row-reverse',
  justifyContent: 'space-between',
  padding: '0 4rem',
  position: 'absolute',
  width: '100%',
  bottom: '0',
});
